import { SlateLogo } from '@carvana/ds-icons';
import Spinner from '@carvana/ds-spinner';
import React from 'react';
import PoweredByCarvana from '|/app/header/slate-header/powered-by-carvana';
import styles from './connect-loading.module.css';

const ConnectLoading: React.FC = () => (
  <div className={styles.page}>
    <div className={styles.content}>
      <Spinner size={57} className={styles.spinner} />
      <div className={styles.brand}>
        <SlateLogo
          className={styles.slateLogo}
          size={163}
          color="currentColor"
          aria-hidden="true"
        />
        <span className={styles.checkout}>Checkout</span>
      </div>
      <PoweredByCarvana className={styles.poweredByCarvana} />
    </div>
  </div>
);

export default ConnectLoading;
